// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { Maximize } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconMaximize(props: any) {
    return <IconBase icon={Maximize} {...props} />
  }

  export default IconMaximize
  